module.exports = __webpack_public_path__ + "img/android-chrome-192x192.d6f16503.png";